<template>
    <div class="folder-tree-item" @contextmenu.prevent.stop="onContextMenu">
        <div
            class="folder-row"
            :class="{ 'folder-row-active': isActive }"
            :style="{ paddingLeft: indent + 'px' }"
            @click="select"
        >
            <span
                class="folder-toggle"
                :class="{ 'folder-toggle-hidden': !hasChildren }"
                @click.stop="toggle"
            >
                <i v-if="hasChildren" :class="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></i>
            </span>
            <i class="pi pi-folder folder-icon"></i>
            <span class="folder-name" :title="folder.name">{{ folder.name }}</span>
            <button
                class="folder-action-btn"
                title="Действия с папкой"
                @click.stop="onActionClick"
            >
                <i class="pi pi-ellipsis-v"></i>
            </button>
        </div>
        <div v-if="hasChildren && expanded" class="folder-children">
            <FolderTreeItem
                v-for="child in folder.children"
                :key="'f-' + child.id"
                :folder="child"
                :active-folder-id="activeFolderId"
                :depth="depth + 1"
                @select="(id) => $emit('select', id)"
                @create-subfolder="(parent) => $emit('create-subfolder', parent)"
                @rename="(f) => $emit('rename', f)"
                @delete="(f) => $emit('delete', f)"
            />
        </div>
    </div>
</template>

<script>
import EventBus from '@/libs/event-bus';
import events from '@/libs/events';

export default {
    name: 'FolderTreeItem',
    props: {
        folder: { type: Object, required: true },
        activeFolderId: { type: Number, default: null },
        depth: { type: Number, default: 0 },
    },
    emits: ['select', 'create-subfolder', 'rename', 'delete'],
    data() {
        return {
            expanded: false,
        };
    },
    computed: {
        isActive() {
            return this.activeFolderId === this.folder.id;
        },
        hasChildren() {
            return this.folder.children && this.folder.children.length > 0;
        },
        indent() {
            return 12 + this.depth * 16;
        },
    },
    watch: {
        activeFolderId(val) {
            if (val === this.folder.id) {
                this.expanded = true;
            }
        },
    },
    mounted() {
        if (this.isActive) {
            this.expanded = true;
        }
    },
    methods: {
        toggle() {
            this.expanded = !this.expanded;
        },
        select() {
            this.$emit('select', this.folder.id);
        },
        createSubfolder() {
            this.$emit('create-subfolder', this.folder);
        },
        onActionClick(event) {
            this.$emit('select', this.folder.id);
            EventBus.$emit(events.FOLDER_CONTEXT_MENU, { folder: this.folder, event });
        },
        onContextMenu(event) {
            this.$emit('select', this.folder.id);
            EventBus.$emit(events.FOLDER_CONTEXT_MENU, { folder: this.folder, event });
        },
    },
};
</script>

<style scoped>
.folder-tree-item {
    user-select: none;
}

.folder-row {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 5px 12px;
    cursor: pointer;
    border-radius: 4px;
    transition: background 0.15s;
    position: relative;
}

.folder-row:hover {
    background: #e9ecef;
}

.folder-row-active {
    background: #dbeafe;
    color: #0059a9;
}

.folder-row-active:hover {
    background: #c7dffc;
}

.folder-toggle {
    width: 16px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.folder-toggle i {
    font-size: 0.65rem;
    color: #6c757d;
}

.folder-toggle-hidden {
    visibility: hidden;
}

.folder-icon {
    font-size: 0.85rem;
    color: #ffc107;
    flex-shrink: 0;
}

.folder-row-active .folder-icon {
    color: #0059a9;
}

.folder-name {
    font-size: 0.85rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
    min-width: 0;
    text-align: left;
}

.folder-action-btn {
    opacity: 0;
    background: none;
    border: none;
    cursor: pointer;
    padding: 2px 6px;
    border-radius: 4px;
    color: #6c757d;
    font-size: 0.7rem;
    flex-shrink: 0;
    transition: opacity 0.15s, background 0.15s;
}

.folder-row:hover .folder-action-btn {
    opacity: 1;
}

.folder-action-btn:hover {
    background: #dee2e6;
    color: #495057;
}

/* Make action visible on touch devices */
@media (hover: none) {
    .folder-action-btn {
        opacity: 0.6;
    }
}
</style>
